exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkmark {\n  top: 0;\n  left: 0;\n  height: 25px;\n  width: 25px;\n  background-color: #eee; }\n\n.back-button {\n  border-radius: 50%;\n  border-color: #56565A;\n  border-width: 1px;\n  border-style: solid;\n  height: 30px;\n  width: 30px;\n  margin-top: 20px;\n  margin-left: 15px; }\n\na.back-button:hover {\n  background-color: #56565A; }\n  a.back-button:hover i.back-button-icon {\n    color: #FFFFFF !important; }\n\n.back-button-icon {\n  margin-left: 10px;\n  margin-top: 7px;\n  color: #56565A;\n  font-size: 15px; }\n\n.marketplace-filter {\n  position: absolute;\n  left: 0px; }\n\n.cards-and-dropdown {\n  position: absolute;\n  right: 0px; }\n\n.marketplace-title {\n  font-size: 34px;\n  color: #707070;\n  margin-left: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/productStandardFlowList.component.scss
// module id = ../../../../../src/app/private/dynamicFlow/productStandardFlowList.component.scss
// module chunks = main